export function getImageData(
  image: HTMLImageElement,
  x: number,
  y: number,
  width: number,
  height: number,
  ctx = document.createElement("canvas").getContext("2d")
) {
  ctx.drawImage(image, 0, 0);
  return ctx.getImageData(x, y, width, height);
}

export function getImageDataColor(data: Uint8ClampedArray, i: number) {
  const r = data[i];
  const g = data[i + 1];
  const b = data[i + 2];
  const a = data[i + 3];
  return `rgba(${r},${g},${b},${(a / 255).toFixed(2)})`;
}

interface IPixelatedContext {
  fillStyle: string | CanvasGradient | CanvasPattern;
  fillRect(x: number, y: number, w: number, h: number): void;
}

const getIndexFromPos = (x: number, y: number, width: number) =>
  (y * width + x) * 4;

export function drawPixelated(
  ctx: IPixelatedContext,
  imageData: ImageData,
  scale: number = 1
) {
  for (let x = 0; x < imageData.width; x++) {
    for (let y = 0; y < imageData.height; y++) {
      const color = getImageDataColor(
        imageData.data,
        getIndexFromPos(x, y, imageData.width)
      );
      ctx.fillStyle = color;
      ctx.fillRect(x * scale, y * scale, scale, scale);
    }
  }
}
